<template>
  <v-app light>

    <navbar></navbar>

    <v-content>

      <v-container fluid>
        <router-view></router-view>
      </v-container>

    </v-content>

    <app-footer></app-footer>

  </v-app>
</template>

<script>
  import Navbar from '@/components/Navbar';
  import AppFooter from '@/components/AppFooter';

  export default {

    name: 'Layout',

    components: {
      Navbar,
      AppFooter,
    },

  };
</script>



// WEBPACK FOOTER //
// src/components/Layout.vue